import React, { useState, useTransition } from "react";
import { Tabs, Tab } from "@mui/material";
import {withStyles} from "@material-ui/core/styles"
import { Grid } from "@mui/material";
import customStyle from '../../../../Assets/CSS/stylesheet_UHS';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from "@material-ui/core/Fab";

const CrudButton = withStyles(
    customStyle.crudBtnAgent,
)(Fab);

/**
 * TabView Component
 * @param {Object} props - Component props
 * @param {string} [props.backgroundColor] - Background color for tabs
 * @param {Array} props.data - Array of tab data
 * @param {number} [props.active] - Default active tab index
 */
const TabView = ({ backgroundColor = "#fff", data = [], active = 0, countData = {}, empid = "", isAcknowledged = true }) => {
  const [value, setValue] = useState(active);
  const [isPending, startTransition] = useTransition();

  const handleChange = (event, newValue) => {
    startTransition(() => {
      setValue(newValue);
    });
  };

  const TabPanel = ({ children, value, index }) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`custom-tabpanel-${index}`}
        aria-labelledby={`custom-tab-${index}`}
        style={{
          backgroundColor: "#ffffff",
          opacity: isPending ? 0.5 : 1,
          transition: "opacity 0.3s ease",
        }}
      >
        {value === index && <>{children}</>}
      </div>
    );
  };

  if (!data.length) return <div>No tabs available</div>;

  return (
    <div>
      {
        isAcknowledged &&
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="styled tabs"
        sx={{
          background: backgroundColor,
          transition: "background-color 0.3s ease",
        }}
        TabIndicatorProps={{ style: { display: "none" } }}
      >
        {data.map((tab, i) => (
          <Tab
            key={`tab-${i}`}
            label={tab.label || ""}
            disabled={tab.disable || false}
            sx={{
              color: tab.color || "",
              bgcolor: value === i ? tab.selectedbgColor : tab.bgcolor || "",
              fontWeight: "500",
              transition: "background-color 0.3s ease, color 0.3s ease",
              "&.Mui-selected": {
                color: tab.selectedColor || "",
              },
              "&.Mui-disabled": {
                color: "#c8c8c8",
              },
            }}
            id={`custom-tab-${i}`}
            aria-controls={`custom-tabpanel-${i}`}
          />
        ))}
      </Tabs>
      }
      {data.map((tab, index) => (
        <TabPanel key={`tabpanel-${index}`} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </div>
  );
};

export default TabView;
